import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import lancarRelatorioBNCCSemestralPage from "@/Pages/Relatorios/lancarRelatorioBNCCSemestralPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";

export default [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCCSemestral/:matricula_id",
    name: "relatorios.lancarRelatorioBNCCSemestral",
    component: lancarRelatorioBNCCSemestralPage,
  },
];
